import { create } from "zustand";
import type { OrderRealtimeEvent } from "@utils/realtime/orderRealtimeSession";

/**
 * 訂單即時通知的「事件匯流排」。
 *
 * 連線只有一條，由 PageWrapper 掛（useOrderRealtimeConnection）：列表與詳情共用同一個頻道，
 * 在兩頁之間切換不必斷線重連。但要反應事件的是列表與詳情頁本身，兩邊隔著 router 的 Outlet，
 * 沒有 props 可傳，所以用 store 接（比照 useTrackingHero）。
 *
 * 用序號（eventSeq / resumeSeq）而不是只存最後一個值：同一個事件物件、或連續兩次 resume
 * 在值上分不出來，序號遞增才保證每一次都會通知到（頁面端見 useOrderRealtimeListener）。
 */
interface OrderRealtimeState {
  status: "idle" | "connecting" | "subscribed" | "disconnected";
  /** 每收到一個有效事件 +1 */
  eventSeq: number;
  lastEvent: OrderRealtimeEvent | null;
  /** 每次需要「整頁補抓」（回到前景、斷線後重新接上）+1 */
  resumeSeq: number;
  setStatus: (s: OrderRealtimeState["status"]) => void;
  pushEvent: (e: OrderRealtimeEvent) => void;
  bumpResume: () => void;
}

export const useOrderRealtime = create<OrderRealtimeState>((set) => ({
  status: "idle",
  eventSeq: 0,
  lastEvent: null,
  resumeSeq: 0,
  setStatus: (status) => set((prev) => (prev.status === status ? prev : { status })),
  pushEvent: (e) => set((prev) => ({ eventSeq: prev.eventSeq + 1, lastEvent: e })),
  bumpResume: () => set((prev) => ({ resumeSeq: prev.resumeSeq + 1 })),
}));
